import {
  TEAM_DETAILS_INIT,
  TEAM_DETAILS_LOADING,
  TEAM_DETAILS_NOT_SUPPORTED,
  TEAM_DETAILS_SET_TEAM,
  YEAR_GAMES_STARTLIST,
} from "./teamDetailsActions";
import {
  TEAM_DETAILS_SET_STAGE,
  TEAM_DETAILS_STAGES_OFFSET,
} from "./classificationListActions";

import { isMobile } from "../utils/common";

const stagesShown = isMobile() ? 2 : 5;

const defaultState = {
  team: null,
  Startlist: [],
  ownTeams: [],
  stages: [],
  stagesOffset: 0,
  columns: [],
  show: false,
  activeStage: null,
  perStage: false,
  separatePerStage: false,
  loading: false,
};

export const teamDetailsReducer = (state = defaultState, action) => {
  switch (action.type) {
    
    case YEAR_GAMES_STARTLIST:
      return {
        ...state,
        Startlist: {
          yearGames: action.payload.yearGamesData,
          supermatch: action.payload.supermatchData,
        },
      };

    case TEAM_DETAILS_LOADING:
      return {
        ...state,
        loading: true,
      };

    case TEAM_DETAILS_INIT:
      let stageOffsetInit, gameStatusFalse;

      if (action.payload.stages){
        gameStatusFalse = action.payload.stages.filter(stage => stage.gameStatus === false).length;
        if(gameStatusFalse >= 2){
          stageOffsetInit = gameStatusFalse - 2;
        }
        else if(gameStatusFalse == 1){
          stageOffsetInit = gameStatusFalse - 1;
        }
        else{
          stageOffsetInit = 0;
        }
      }
      else{
        stageOffsetInit = 0;
      }
      
      return {
        ...state,
        team: null,
        perStage: action.payload.perStage,
        separatePerStage: action.payload.separatePerStage,
        ownTeams: action.payload.ownTeams,
        
        stages: action.payload.stages && action.payload.stages
          .map((stage, i, arr) => {
            if (stage.gameStatus) {
              const filteredStages = arr.filter(s => s.gameStatus);
              const index = filteredStages.length - filteredStages.indexOf(stage);
              
              return {
                ...stage,
                index: index,
              };
            } else {
              const trueStages = arr.filter(s => s.gameStatus);
              const falseStages = arr.filter(s => !s.gameStatus);
              const index = trueStages.length + (falseStages.length - falseStages.indexOf(stage));
              return {
                ...stage,
                index: index,
              };
            }
          }),
      
        columns: action.payload.columns,
        achievements: action.payload.achievements,
        stagesOffset: stageOffsetInit,
        show: true,
        activeStage: action.payload.stages ? action.payload.stages.filter(stage => stage.gameStatus === true).length : action.payload.stages.length,
        

      };
      
    case TEAM_DETAILS_SET_STAGE:
      return {
        ...state,
        activeStage: action.payload,
      };

    case TEAM_DETAILS_STAGES_OFFSET: {
      let newOffset = state.stagesOffset + action.payload;
      if (state.stages.length - stagesShown >= newOffset && newOffset >= 0) {
        return {
          ...state,
          stagesOffset: state.stagesOffset + action.payload,
        };
      } else {
        return state;
      }
    }
    case TEAM_DETAILS_SET_TEAM:
      return {
        ...state,
        team: action.payload,
        loading: false,
      };
    case TEAM_DETAILS_NOT_SUPPORTED:
      return {
        ...state,
        show: true,
        team: action.payload,
        ownTeams: [],
        stages: [],
        stagesOffset: 0,
        columns: [],
        loading: false,
      };
    default:
      return state;
  }
};
